import type { Cesium3DTileset, Viewer } from 'cesium';
import { useEffect, useState } from 'react';
import { isLimitBoxAvailable } from '@/helper/clipping-box-placement';

/**
 * Whether a model is close enough for the limit box. Checked when the viewer or the loaded
 * layers change and whenever a camera movement ends.
 */
export const useLimitBoxAvailable = (viewer: Viewer | null | undefined, tilesets: Cesium3DTileset[]) => {
	const [available, setAvailable] = useState(false);

	useEffect(() => {
		if (!viewer) {
			setAvailable(false);
			return;
		}
		// moveEnd is raised inside Cesium's render loop, where an exception stops all rendering.
		const check = () => {
			if (viewer.isDestroyed()) return;
			try {
				setAvailable(isLimitBoxAvailable(viewer, tilesets));
			} catch (error) {
				console.warn('Limit box availability check failed', error);
				setAvailable(false);
			}
		};
		check();
		return viewer.camera.moveEnd.addEventListener(check);
	}, [viewer, tilesets]);

	return available;
};
